import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8,5.7c1.2,0,2.3,1,2.3,2.3c0,1.2-1,2.3-2.3,2.3c-1.2,0-2.3-1-2.3-2.3S6.8,5.7,8,5.7L8,5.7z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.1,8.9L1.7,10c-0.5,0.4-0.6,1.1-0.3,1.6l0.2,0.3c0.3,0.5,1,0.8,1.5,0.5l1.6-0.7 c0.5,0.4,1,0.7,1.6,0.9l0.2,1.7c0.1,0.6,0.6,1.1,1.2,1.1h0.3c0.6,0,1.1-0.5,1.2-1.1l0.2-1.7c0.6-0.2,1.1-0.5,1.6-0.9l1.6,0.6 c0.6,0.2,1.2,0,1.5-0.5l0.2-0.3c0.3-0.5,0.2-1.2-0.3-1.6l-1.4-1.1c0.1-0.6,0.1-1.2,0-1.9l0,0L14.3,6c0.5-0.4,0.6-1.1,0.3-1.6 l-0.2-0.3c-0.3-0.5-1-0.8-1.5-0.5l-1.6,0.7c-0.5-0.4-1-0.7-1.6-0.9L9.4,1.6C9.3,1,8.8,0.5,8.2,0.5H7.8C7.2,0.5,6.7,1,6.6,1.6 L6.3,3.3C5.8,3.5,5.2,3.8,4.8,4.2L3.1,3.6c-0.6-0.2-1.2,0-1.5,0.5L1.4,4.4C1.1,4.9,1.2,5.6,1.7,6l1.4,1.1C3,7.7,3,8.3,3.1,8.9"
	})] })
});
export { SvgIconSettings as ReactComponent };
